import Field, { type Flavor } from '../../Field';
import terminology from 'javascripts/terminology';
import { type CardLayoutModelType } from '../../types';
import { type FieldContentsData } from 'javascripts/shared-types';

type GoalIconModel = Extract<CardLayoutModelType, { goals: any[] }>;

export class GoalIcon extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['roadmap'];
  }

  static subqueriesForModel() {
    return { goals: ['color'] };
  }

  get title() {
    return `${terminology('Goal')} icon`;
  }

  exampleContents(): FieldContentsData {
    return {
      icon: { name: 'fa-solid fa-flag', color: '#B540BF' },
    };
  }

  contentsForRecord(record: GoalIconModel): FieldContentsData {
    if (record.goals?.length) {
      return {
        icon: {
          name: 'fa-solid fa-flag',
          color: record.goals[0].colorObject.hex(),
        },
      };
    }

    return {};
  }
}
